import React from 'react';
import { styled } from "../../../stitches.config"
import Link from "../../../components/Link";

import backgroundLeft from "./assets/footer-desktop-left.png"
import backgroundRight from "./assets/footer-desktop-right.png"
import backgroundMobile from "./assets/footer-background-mobile.jpg"
import logo from "./assets/header-logo.svg"


import { ReactComponent as Button } from "./assets/footer-btn.svg?react"
import { ReactComponent as Text } from "./assets/footer-napis.svg?react"
import { ReactComponent as Email } from "./assets/footer-mail.svg?react"


interface AtavistTestingFooterProps {
    link: string;
}

const AtavistTestingFooter: React.FC<AtavistTestingFooterProps> = ({
    link
}) => {
    const isDesktop = window.innerWidth >= 996;
    return (
        <Wrapper>
            {isDesktop ?
                <BackgroundDesktop>
                    <LeftSide>
                        <Text className="text-svg" />
                    </LeftSide>
                    <RightSide>
                        <Logo></Logo>
                        <a href="mailto:kontakt@mamadu.pl">
                            <Email className="email-svg" />
                        </a>
                    </RightSide>
                </BackgroundDesktop>
                :
                <StyledAtavistTestingFooter>
                    <Text className="text-svg" />
                    <Logo></Logo>
                    <a href="mailto:kontakt@mamadu.pl">
                        <Email className="email-svg" />
                    </a>
                </StyledAtavistTestingFooter>
            }
            <Link to={link}>
                <Button className="btn-svg" />
            </Link>
        </Wrapper >
    );
};


const StyledAtavistTestingFooter = styled('div', {
    backgroundImage: `url("${backgroundMobile}")`,
    height: "510px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    position: "relative",
    maxWidth: "500px",
    margin: "0 auto",
})

const Wrapper = styled('div', {
    fontFamily: "$charis",
    fontWeight: "700",
    ".btn-svg": {
        width: "320px",
        marginLeft: "calc(50% - 160px)",
        marginTop: "48px",
        cursor: "pointer",
        "&:hover": {
            ".stf00": {
                transition: "0.3s",
                fill: "#2dcdcc",
            }
        },
        "@media(min-width: 480px)": {
            width: "390px",
            marginLeft: "calc(50% - 190px)",
        },
        "@bp4": {
            width: "490px",
            marginLeft: "calc(50% - 245px)",
        }
    },
    ".text-svg": {
        width: "245px",
        position: "absolute",
        left: "20px",
        top: "5px",
        "@media(min-width: 480px)": {
            width: "280px",
            top: "20px",
        }
    },
    ".email-svg": {
        width: "280px",
        position: "absolute",
        left: "calc(50% - 140px)",
        bottom: "20px",
        "@bp4": {
            bottom: "250px",
        },
        ".st0": {
            transition: "0.3s",
            fill: "#FFC437",
        },
        ".st2": {
            strokeWidth: "0.1",
        },
        "&:hover": {
            ".st0": {
                transition: "0.3s",
                fill: "#2dcdcc",
            }
        },
    }
})

const BackgroundDesktop = styled('div', {
    height: "510px",
    width: "100%",
    position: "relative",
    display: "flex",
})

const Logo = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${logo}")`,
    height: "66px",
    width: "45px",
    position: "absolute",
    right: "30px",
    bottom: "175px",
    "@bp4": {
        height: "150px",
        width: "102px",
        right: "calc(50% - 51px)",
        bottom: "320px",
    }
})

const LeftSide = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${backgroundLeft}")`,
    position: "relative",
    width: "60%",
})

const RightSide = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${backgroundRight}")`,
    position: "relative",
    width: "40%",
})

export default AtavistTestingFooter